export default "__VITE_ASSET__Clp9t_RY__"